// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"efd31b51","772":"376748b4","812":"92eba169"}[chunkId] + ".chunk.css";
};